// extracted by mini-css-extract-plugin
export var checkbox = "_72-0";
export var circle = "_72-3";
export var horizontalContainer = "_72-7";
export var sm = "_72-5";
export var switch0 = "_72-2";
export var switchDisabled = "_72-8";
export var switchEnabled = "_72-1";
export var textSwitchContainer = "_72-9";
export var textSwitchOption = "_72-a";
export var textSwitchOptionSelected = "_72-b";
export var verticalContainer = "_72-6";
export var xs = "_72-4";